import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { getCoordinatesRelativeToDocument } from 'utils/utils';
import './CustomControl.scss';

export default class CustomControl extends Component {
  static propTypes = {
    body: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    position: PropTypes.string,
    hAlign: PropTypes.string,
    customControlState: PropTypes.object,
    closeCustomControl: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  };

  static defaultProps = {
    body: '',
    position: 'top',
    hAlign: 'center',
    customControlState: {},
    width: 300,
    height: 'auto',
  }

  componentDidMount() {
    window.addEventListener('keyup', this.closeControlWithEscape);
  }

  shouldComponentUpdate = shouldPureComponentUpdate;

  componentWillUnmount() {
    window.removeEventListener('keyup', this.closeControlWithEscape);
  }

  closeControlWithEscape = (event) => {
    const { closeCustomControl } = this.props;
    const escapeKeycode = 27;

    if (event.keyCode === escapeKeycode && closeCustomControl) {
      closeCustomControl(event);
    }
  };

  closeControl = (event) => {
    event.preventDefault();
    const { closeCustomControl } = this.props;

    closeCustomControl(event);
  };

  render() {
    const {
      body,
      position,
      customControlState,
      hAlign,
      closeCustomControl,
      width,
      height,
    } = this.props;

    const coordinates = getCoordinatesRelativeToDocument(customControlState.boundingClientRect);
    const dimensionStyles = { width: customControlState.width || 300, maxHeight: height };
    const positionStyles = {};

    if ((position === 'top' || position === 'bottom') && customControlState.boundingClientRect) {
      if (hAlign === 'left') {
        positionStyles.left = coordinates.left;
      } else if (hAlign === 'center') {
        positionStyles.left = (coordinates.left - (width / 2)) + (customControlState.boundingClientRect.width / 2);
      }
    }

    if (position === 'top' && customControlState.boundingClientRect) {
      positionStyles.top = coordinates.top + customControlState.boundingClientRect.height;
    }

    if (position === 'bottom' && customControlState.boundingClientRect) {
      positionStyles.top = coordinates.top;
    }

    if (position === 'right' && customControlState.boundingClientRect) {
      positionStyles.left = coordinates.left + customControlState.boundingClientRect.width;
      positionStyles.top = coordinates.top;
    }

    if (customControlState.yOffset) {
      positionStyles.top += customControlState.yOffset;
    }

    return (
      <div className="custom-control">
        <div onClick={closeCustomControl} className="custom-control__screen" />
        <div className="custom-control__inner" style={positionStyles} data-custom-control-wrapper>
          <div
            className={`custom-control__content custom-control__content--${position} custom-control__content--${height !== 'auto' && 'fixed-height'} ${customControlState.hasTopArrow ? 'custom-control__content--has-top-arrow' : ''}`}
            style={dimensionStyles}
          >
            { customControlState.hasCloseButton && (
              <a href="#" onClick={this.closeControl} className="custom-control__close" />
            )}
            <div className="custom-control__text">
              { typeof body === 'string' ? <div dangerouslySetInnerHTML={{ __html: body }} /> : body }
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CustomControl/CustomControl.jsx
 **/